import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["link", "checkbox"]

  connect() {
    // set initial state
    this.removeOtherCheckboxTarget()
    this.updateLinkText()
  }

  toggle(event) {
    event.preventDefault()
    const areAllChecked = this.checkboxTargets.every((cb) => cb.checked)

    // Toggle the checked state
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = !areAllChecked
    })

    // Notify of change
    const changeEvent = new CustomEvent("change", { bubbles: true })
    this.element.dispatchEvent(changeEvent)
  }

  updateLinkText() {
    const areAllChecked = this.checkboxTargets.length > 0 && this.checkboxTargets.every((cb) => cb.checked)
    this.linkTarget.textContent = areAllChecked ? "Unselect all" : "Select all"
  }

  // we don't want to select-all this one
  // because it'll leave the form in an invalid state
  removeOtherCheckboxTarget() {
    this.checkboxTargets.forEach((checkbox) => {
      if (checkbox.value == "other") {
        delete checkbox.dataset.selectAllTarget
      }
    })
  }
}
